var SignalFrequency;!function(e){e.OncePerVisit="visit",e.Once="once",e.Always="always"}(SignalFrequency=SignalFrequency||{});export{SignalFrequency};